import { Variants } from '@amplitude/experiment-js-client';
import {
    LookUpFromAmplitudeFeatureFlagNameToCNPKey,
    GraceFeatureFlags,
} from '../featureFlags';
import { AmpFlagSet, AmpFlagValue } from '../amplitude';
import {
    AMPLITUDE_DISABLE,
    AMPLITUDE_DISABLED,
    AMPLITUDE_ENABLE,
    AMPLITUDE_ENABLED,
    AMPLITUDE_FALSE,
    AMPLITUDE_ON,
    AMPLITUDE_TRUE,
} from '../constants';

export function validateInteger(value: string) {
    return /^\d+$/.test(value);
}

export const translateFFValue = (value?: AmpFlagValue): AmpFlagValue => {
    switch (value) {
        case AMPLITUDE_ON:
        case AMPLITUDE_TRUE:
        case AMPLITUDE_ENABLED:
            return true;
        case AMPLITUDE_FALSE:
        case AMPLITUDE_DISABLED:
            return false;
        case AMPLITUDE_ENABLE:
            return 'enable';
        case AMPLITUDE_DISABLE:
            return 'disable';
    }
    if (typeof value === 'string' && validateInteger(value)) {
        return parseInt(value);
    }
    return value || false; // Default to false if no value is provided
};

// Translate amplitude feature flags to the format used by the client
export const translateAmplitudeFFs = (variants: Variants) => {
    const translatedFlags: AmpFlagSet = {};
    const expectedFeatureFlags = { ...GraceFeatureFlags };
    Object.keys(variants).forEach((key: string) => {
        // Sometimes the key names in amplitude are different than the names
        // referenced throughout the CNP code base.  This is tech debt and should be deprecated eventually.
        if (key in LookUpFromAmplitudeFeatureFlagNameToCNPKey) {
            const commonFFName: string =
                LookUpFromAmplitudeFeatureFlagNameToCNPKey[
                    key as keyof typeof LookUpFromAmplitudeFeatureFlagNameToCNPKey
                ];
            if (commonFFName in GraceFeatureFlags) {
                const graceFlagName =
                    GraceFeatureFlags[
                        commonFFName as keyof typeof GraceFeatureFlags
                    ];
                translatedFlags[graceFlagName] = translateFFValue(
                    variants[key].value
                );
                // Remove the flag from expectedFeatureFlags - keys left on this object after the loop will be defaulted to false.
                commonFFName in expectedFeatureFlags &&
                    delete expectedFeatureFlags[
                        commonFFName as keyof typeof expectedFeatureFlags
                    ];
                return;
            }
        }
        // fall back to the original key if no translation is found
        translatedFlags[key] = translateFFValue(variants[key].value);
    });

    // Add any expected feature flags that were not found in the variants
    // this may happen, for instance, if a feature flag is "deactivated" in amplitude
    Object.keys(expectedFeatureFlags).forEach((flagName) => {
        const cnpFlagName =
            expectedFeatureFlags[flagName as keyof typeof expectedFeatureFlags];
        if (!(cnpFlagName in translatedFlags)) {
            translatedFlags[cnpFlagName] = false; // Default to false if not found
        }
    });

    return translatedFlags;
};
